<template>
  <div id="generate-boxes">
    <template v-if="startedGenerating">
      <div class="generating">
        <loader-ring />
      </div>
    </template>
    <template v-if="!startedGenerating">
      <div class="error-messages-modal-part" v-if="errorMessage">
        <ul class="error-list">
          <li class="error-message">
            {{ errorMessage }}
          </li>
        </ul>
      </div>
      <div class="input-fields-part">
        <div class="count">
          <basic-input
            type="number"
            :label="$t('storeScreen.generateBoxes.inputs.count.label')"
            :placeholder="$t('storeScreen.generateBoxes.inputs.count')"
            class="QRNumber-input row"
            v-model="count"
          />
        </div>
        <div class="type">
          <basic-select
            :label="$t('storeScreen.generateBoxes.inputs.type.label')"
            :placeholderText="$t('storeScreen.generateBoxes.inputs.type')"
            class="type-input"
            v-model="type"
          >
            <basic-select-item :value="0" :text="$variables.boxTypes[0]" />
            <basic-select-item :value="1" :text="$variables.boxTypes[1]" />
            <basic-select-item :value="2" :text="$variables.boxTypes[2]" />
          </basic-select>
        </div>
      </div>
      <div class="button-wrapper">
        <rounded-button
          :disabled="isButtonDisabled"
          @click="generate"
          width="60%"
          :position="'center'"
        >
          {{ $t("storeScreen.generateBoxes.generate") }}
        </rounded-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "GenerateBoxes",
  props: {},
  components: {},
  data: () => ({
    count: undefined,
    type: undefined,
    errorMessage: undefined,
    startedGenerating: false
  }),
  created() {},
  computed: {
    isButtonDisabled() {
      return !(this.count && this.count !== 0 && this.type !== undefined);
    },
    computedBody() {
      return {
        count: this.count,
        type: this.type
      };
    }
  },
  methods: {
    ...mapActions({
      generateBoxes: "boxes/generateBoxes"
    }),
    generate() {
      this.startedGenerating = true;
      this.generateBoxes(this.computedBody)
        .then(res => {
          if (res.status === "OK") {
            this.$eventBus.closeModal();
            this.$emit("refreshData");
            this.$notification.showNoti("success", "generateBoxes.success");
            this.startedGenerating = false;
          } else {
            this.$eventBus.closeModal();
            this.$notification.showNoti("error", null, res);
            this.startedGenerating = false;
          }
        })
        .catch(() => {
          this.$eventBus.closeModal();
          this.startedGenerating = false;
          this.$notification.showNoti("error", "generateBoxes.success");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#generate-boxes {
  padding: 10px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .input-fields-part {
    div {
      margin-bottom: 15px;
    }
  }
  .button-wrapper {
    margin-top: 10px;
  }
  .generating {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
</style>
